<template>
  <div>
    <v-form ref="form" class="mx-2" lazy-validation>
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field ref="nationalCode" v-model="localData.nationalCode" label="کد ملی" :error-messages="errorMessages" :rules="[() => !!localData.nationalCode || 'کد ملی را وارد کنید']" disabled />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field ref="username" v-model="localData.userName" label="نام کاربری" disabled />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field ref="regDate" v-model="regDate" label="تاریخ عضویت" disabled />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field ref="firstName" v-model="localData.firstName" label="نام*" :error-messages="errorMessages" :rules="[() => !!localData.firstName || 'نام را وارد کنید']" required />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field ref="lastName" v-model="localData.lastName" label="نام خانوادگی*" :error-messages="errorMessages" :rules="[() => !!localData.lastName || 'نام خانوادگی را وارد کنید']" required />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field ref="fatherName" v-model="localData.fatherName" label="نام پدر*" :error-messages="errorMessages" :rules="[() => !!localData.fatherName || 'نام پدر را وارد کنید']" required />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field ref="mobile" v-model="mobile" label="موبایل*" :error-messages="errorMessages" disabled />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field ref="phone" v-model="localData.phone" label="تلفن ثابت*" />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field ref="email" v-model="localData.email" label="ایمیل*" :error-messages="errorMessages" :rules="[() => !!localData.email || 'ایمیل را وارد کنید']" required />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field ref="city" v-model="localData.city" label="شهر*" :rules="[() => !!localData.city || 'شهر را وارد کنید']" required />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field ref="address" v-model="localData.address" label="آدرس*" :rules="[() => !!localData.address || 'آدرس را وارد کنید', () => !!localData.address && localData.address.length >= 20 || 'طول کاراکترهای آدرس باید حداقل 20 کاراکتر باشد']" required />
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field ref="postalCode" v-model="localData.postalCode" maxlength="10" label="کد پستی*" :error-messages="errorMessages" :rules="[() => !!localData.postalCode || 'کد پستی را وارد کنید']" required />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field v-model="localData.password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[() => !localData.password || !!localData.password || localData.password.length >= 8 || 'حداقل 8 کاراکتر']" :error-messages="errorMessages" :type="show1 ? 'text' : 'password'" name="password" label="کلمه عبور*" persistent-hint hint="در صورت خالی بودن پسورد تغییر نخواهد کرد" @click:append="show1 = !show1" />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field v-model="localData.confirmPassword" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[() => localData.confirmPassword === localData.password || 'تکرار کلمه عبور با کلمه عبور مطابقت ندارد']" :error-messages="errorMessages" :type="show2 ? 'text' : 'password'" name="confirmPassword" label="تکرار کلمه عبور*" @click:append="show2 = !show2" />
        </v-col>
      </v-row>
      <v-row class="my-3">
        <v-col cols="12" md="12" class="py-0">
          <div style="border-radius: 5px;background:#eee;padding: 10px;">
            <div class="text-center secondary--text mb-2">شماره حساب ها</div>
            <v-card v-for="(item, index) in bankAccounts" :key="index" class="mb-3 pa-3" elevation="0" style="border: 1px solid #dca6e5">
              <v-row>
                <v-col cols="12" md="5" class="py-0 my-0">
                  <v-text-field v-model="item.accountNumber" label="شماره کارت*" maxlength="16" :error-messages="errorMessages" :rules="[(val) => !!val || 'شماره کارت را وارد کنید', (val) => !!val && val.length === 16 || 'شماره کارت باید 16 رقم باشد']" required />
                </v-col>
                <v-col cols="12" md="3" class="py-0 my-0">
                  <v-text-field v-model="item.bank" label="بانک*" :error-messages="errorMessages" :rules="[(val) => !!val || 'نام بانک را وارد کنید']" required />
                </v-col>
                <v-col cols="12" md="3" class="py-0 my-0">
                  <v-text-field v-model="item.branch" label="شعبه*" :error-messages="errorMessages" :rules="[(val) => !!val || 'شعبه را وارد کنید']" required />
                </v-col>
                <v-col cols="1" md="1" class="my-0 py-0 d-flex flex-column justify-center">
                  <v-btn @click="removeBankAccount(item, index)" class="" x-small icon dark color="pink" title="حذف">
                    <v-icon dark>
                      mdi-trash-can-outline
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
            <div class="text-center mt-5">
              <v-btn class="mx-auto" color="secondary" dark @click="addBankAccount" small>
                <v-icon dark>
                  mdi-plus-circle-outline
                </v-icon>
                افزودن شماره حساب
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-form>
    <v-card-actions>
      <v-spacer />
      <v-btn @click="$emit('callbck', false)">
        بستن
      </v-btn>
      <v-btn color="blue" dark @click="submit()" :loading="loading">
        ذخیره
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
  import api from '@/util/app-api'
  import toast from '@/util/toast'

  export default {
    name: 'ModifyProfileView',
    components: {
    },
    props: {
      data: { type: Object },
    },
    data() {
      return {
        errorMessages: '',
        localData: {},
        show1: false,
        show2: false,
        regDate: '',
        mobile: '',
        bankAccounts: [],
        loading: false,
      }
    },
    mounted() {
      this.prepareData()
    },
    methods: {
      submit() {
        if (!this.$refs.form.validate()) { return }
        if (!this.bankAccounts.length) {
          toast.error('ثبت حداقل یک شماره حساب الزامی است')
          return
        }
        let data = {}
        data = Object.assign(data, this.localData)
        data.bankAccountsJson = JSON.stringify(this.bankAccounts)
        this.loading = true
        api.post('member/user/edit', data)
          .then(
            response => {
              toast.success('اطلاعات با موفقیت ذخیره شد.')
              this.$emit('callbck', true)
            })
          .catch(err => {
            toast.error(err.message)
          })
          .finally(err => {
            this.loading = false
          })
      },
      prepareData() {
        if (!this.data) {
          this.data = { id: 0 }
        }
        if (!this.data.id) {
          this.data.id = 0
        }
        api.get('member/user/get/', null)
          .then(
            response => {
              this.localData = response
              this.mobile = response.mobile
              this.regDate = response.regDate2_Persian.date
              this.bankAccounts = this.localData.bankAccountsJson ? JSON.parse(this.localData.bankAccountsJson) : []
              if (this.data.id === 0) Object.assign(this.localData, this.data)
            })
          .catch(err => {
            toast.error(err.message)
          })
      },
      removeBankAccount(item, index) {
        this.bankAccounts.splice(index, 1)
      },
      addBankAccount() {
        let newItem = {
          accountNumber: '',
          bank: '',
          branch: '',
        }
        this.bankAccounts.push(newItem)
      },
    },
  }
</script>
<style></style>
